import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIME, isSupabaseConfigured } from '@/config';
import { queryKeys } from '@/lib/data/keys';
import { getMatchNews, getNewsHeadlines, getWcNews } from '@/lib/data/provider';

/** Recent finished matches + events, for the auto-templated News recaps. */
export function useMatchNews(limit = 20) {
  return useQuery({
    queryKey: ['news', 'matches', limit],
    queryFn: () => getMatchNews(limit),
    staleTime: QUERY_STALE_TIME.fixtures,
    enabled: isSupabaseConfigured,
  });
}

/** Latest football headlines for the active language (RSS-sourced, links out). */
export function useNewsHeadlines(lang: 'ar' | 'en', limit = 30) {
  return useQuery({
    queryKey: ['news', 'headlines', lang, limit],
    queryFn: () => getNewsHeadlines(lang, limit),
    staleTime: QUERY_STALE_TIME.fixtures,
    enabled: isSupabaseConfigured,
  });
}

/**
 * World Cup news from 365scores (newest first).
 *   * no fixtureId  -> competition-wide WC news (the News screen / Today hub),
 *   * fixtureId set -> that match's news plus general WC news (the match screen).
 * The provider returns [] on error / when nothing is synced; consumers silent-
 * hide on empty.
 */
export function useWcNews(fixtureId?: string, limit = 30) {
  return useQuery({
    queryKey: queryKeys.wcNews(fixtureId ?? 'all'),
    queryFn: () => getWcNews(fixtureId, limit),
    staleTime: QUERY_STALE_TIME.fixtures,
    enabled: isSupabaseConfigured,
  });
}
